/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RocketOrderSummaryInfoVo
 */
export interface RocketOrderSummaryInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof RocketOrderSummaryInfoVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    orderCode?: string;
    /**
     * 本地运输方式ID
     * @type {number}
     * @memberof RocketOrderSummaryInfoVo
     */
    localTransportMethodId?: number;
    /**
     * 本地运输方式名称
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    localTransportMethodName?: string;
    /**
     * 订单状态
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    orderStatus?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof RocketOrderSummaryInfoVo
     */
    internationalTransportMethodId?: number;
    /**
     * 国际运输方式名称
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    internationalTransportMethodName?: string;
    /**
     * 出库运单号
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    ivc?: string;
    /**
     * 货位
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    location?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    userCode?: string;
    /**
     * 会员id
     * @type {number}
     * @memberof RocketOrderSummaryInfoVo
     */
    userId?: number;
    /**
     * 请求类型
     * @type {string}
     * @memberof RocketOrderSummaryInfoVo
     */
    requestTypeName?: string;
}

/**
 * Check if a given object implements the RocketOrderSummaryInfoVo interface.
 */
export function instanceOfRocketOrderSummaryInfoVo(value: object): value is RocketOrderSummaryInfoVo {
    return true;
}

export function RocketOrderSummaryInfoVoFromJSON(json: any): RocketOrderSummaryInfoVo {
    return RocketOrderSummaryInfoVoFromJSONTyped(json, false);
}

export function RocketOrderSummaryInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RocketOrderSummaryInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'localTransportMethodId': json['localTransportMethodId'] == null ? undefined : json['localTransportMethodId'],
        'localTransportMethodName': json['localTransportMethodName'] == null ? undefined : json['localTransportMethodName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'location': json['location'] == null ? undefined : json['location'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
    };
}

export function RocketOrderSummaryInfoVoToJSON(json: any): RocketOrderSummaryInfoVo {
    return RocketOrderSummaryInfoVoToJSONTyped(json, false);
}

export function RocketOrderSummaryInfoVoToJSONTyped(value?: RocketOrderSummaryInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'localTransportMethodId': value['localTransportMethodId'],
        'localTransportMethodName': value['localTransportMethodName'],
        'orderStatus': value['orderStatus'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'ivc': value['ivc'],
        'location': value['location'],
        'userCode': value['userCode'],
        'userId': value['userId'],
        'requestTypeName': value['requestTypeName'],
    };
}

